"use client";

import Error from "next/error";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  console.log(error);
  return (
    <html>
      <body>
        <Error statusCode={500} title="Erro Fatal Monitorado" />
      </body>
    </html>
  );
}
